import React from 'react';
import { DebugOptionsDrawer } from './DebugOptionsDrawer';
import { AiActivityTrigger } from './AiActivityTrigger';
import { useSessionDebugMode } from '../hooks/useSessionDebugMode';
import { useUserRole } from '../../hooks/useUserRole';

/** Developer debug tools for the Plan page header. */
export function DebugOptionsTools() {
  const sessionDebugMode = useSessionDebugMode();
  const { hasDeveloperOptionsPermission } = useUserRole();

  return (
    <>
      {sessionDebugMode && <AiActivityTrigger />}
      {hasDeveloperOptionsPermission && <DebugOptionsDrawer />}
    </>
  );
}
